/**
 * Opinions Search Hook
 * Hook for Opinions search functionality
 */

import { type OpinionsResponse } from '../../types';

import { useCourtSearch } from './useBaseCourtApi';

/**
 * Hook for Opinions search functionality (Opinions only, not PACER/Cases)
 */
export const useOpinionsSearch = (
  initialQuery: string = '',
  exactMatch: boolean = true
) => {
  const searchHook = useCourtSearch<OpinionsResponse>({
    searchType: 'o',
    queryKeyPrefix: 'opinions-search-v2',
    initialQuery,
    exactMatch,
  });

  return {
    opinionsResults: searchHook.results,
    searchQuery: searchHook.searchQuery,
    sortOption: searchHook.sortOption,

    isSearching: searchHook.isSearching,
    isAnyLoading: searchHook.isAnyLoading,
    hasResults: searchHook.hasResults,
    hasError: searchHook.hasError,
    generalError: searchHook.generalError,
    isTokenLoading: searchHook.isTokenLoading,
    isPaginationLoading: searchHook.isPaginationLoading,

    triggerCombinedSearch: searchHook.triggerCombinedSearch,
    setSortOption: searchHook.setSortOption,
    updateOpinionsResults: searchHook.updateResults,
    setPaginationLoading: searchHook.setPaginationLoading,
    setSearchExecuted: searchHook.setSearchExecuted,

    error: searchHook.error,
    data: searchHook.data,
    refetch: searchHook.refetch,
  };
};
